import axiosApi from "../../components/Api/Axios";
import AuditDetailsView from "../../Models/Audit/AuditDetailsView";
import BackendServices from "../../components/Api/BackendService";

export default (id: string | number) =>
  axiosApi.get<AuditDetailsView>(
    `${BackendServices.AUDIT_SERVICE.AUDIT}/Recall/${id}`
  );
